import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

function snakeSortParams(params) {
  const sorts = params.getAll('sort').map((item) => {
    const [id, direction] = item.split(',');
    const snakeId = id.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
    return `${snakeId},${direction || 'asc'}`;
  });
  params.delete('sort');
  sorts.forEach((item) => params.append('sort', item));
  return params;
}

/** 多值篩選以逗號送（be doc abbce90d：重複 filter key 回 400）。 */
export async function fetchMiscPurchaseOrderList(listQuery) {
  const { data: raw } = await request.get('/srm/misc-purchase-order', {
    params: snakeSortParams(listQueryToApiParams(joinMultiValueFilters(listQuery))),
  });
  return parseVer4ListResponse(raw);
}
